export enum SubCustomersRequestStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  CancelledByPrimaryCustomer = 'CancelledByPrimaryCustomer',
  CancelledBySubCustomer = 'CancelledBySubCustomer',
}

export interface ISubCustomersRequest {
  id: number;
  subCustomerPhoneNumber: string;
  primaryCustomerId: string;
  primaryCustomerPhoneNumber: string;
  primaryCustomerName: string;
  requestStatus: SubCustomersRequestStatus;
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
}
